/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'

import { range } from '~cartzillagb/util'

class BrandsPlaceholder extends Component {

	render() {
		const {
			enableCarousel,
			number,
			columns,
			slidesToShow,
		} = this.props

		const limit = enableCarousel ? slidesToShow : number

		const anchorClass = enableCarousel ? ' thumbnail px-0 border py-4 py-sm-5 px-2' : ' box-shadow-sm rounded-lg py-3 py-sm-4 mb-grid-gutter'

		const contentHTML = (
			<div className={ anchorClass }>
				<div className="bg-muted" style={ { 
					width: '8rem',
					height: '3rem',
					minWidth: '60%',
					maxWidth: '80%',
					margin: '0 auto'
				} }></div>
			</div>
		)

		const output = (
			<div className={ classnames( [
				'brand-thumbnails',
				enableCarousel ? `mx-0 border-right columns-${slidesToShow}` : `columns-${columns}`
			], {} ) }>
				{ range( 1, limit + 1 ).map( i => {
					return(
						enableCarousel ? contentHTML : (
							<div className="thumbnail" key={ i }>
								{ contentHTML }
							</div>
						)
					)
				} ) }
			</div>
		)

		return output
	}
}

export default BrandsPlaceholder